import React, { memo } from 'react';
import {
  ListItem as ListItemContainer,
  ListItemAvatar,
  ListItemText,
  Avatar,
  Icon,
} from '@material-ui/core';

import Loading from './Loading';
import useStyles from './styles';

const ListItem = ({ _id, name, area, onClick, loading }) => {
  const classes = useStyles();
  return (
    <ListItemContainer className={classes.container} button onClick={onClick}>
      {loading ? (
        <Loading />
      ) : (
        <>
          <ListItemAvatar>
            <Avatar className="item-avatar-container">
              <Icon>person</Icon>
            </Avatar>
          </ListItemAvatar>
          <ListItemText
            className="item-text-container"
            primary={name}
            primaryTypographyProps={{
              variant: 'body2',
            }}
            secondary={area}
            secondaryTypographyProps={{
              variant: 'caption',
              color: 'inherit',
              className: 'item-text-area',
            }}
          />
          <Icon className="item-icon-go" color="inherit">
            chevron_right
          </Icon>
        </>
      )}
    </ListItemContainer>
  );
};

export default memo(ListItem);
